/* import __COLOCATED_TEMPLATE__ from './confirmation.hbs'; */
import { bool, or } from '@ember/object/computed';
import Component from '@ember/component';
import { computed } from '@ember/object';
import { htmlSafe } from '@ember/template';
import { task } from 'ember-concurrency';
import { BUTTON_TYPES } from "../../constants/lsg";
import { closeModal } from 'sh-www/utils/modal-controls';

const WIDTHS = {
  SMALL: '400_px',
  MEDIUM: '600_px',
  LARGE: '800_px',
};

const ConfirmationModal = Component.extend({
  tagName: '',

  hasTitleText: bool('model.titleText'),
  hasBodyText: bool('model.bodyText'),
  hasIcon: or('model.iconName', 'model.iconComponentPath'),
  hasActionButtonText: bool('model.actionButtonText'),
  hasCancelButtonText: bool('model.cancelButtonText'),

  /**
   * @param {String=}     Optional button type for the action button. of type BUTTON_TYPES.*
   */
  actionButtonLsgButtonType: computed('model.actionButtonLsgButtonType', function() {
    let buttonType = this.get('model.actionButtonLsgButtonType');

    return buttonType ?
      buttonType :
      BUTTON_TYPES.PRIMARY_SMALL;
  }),

  /**
   * @type {'small'|'medium'|'large'} The width of the modal.
   */
  width: computed('model.width', function() {
    const width = (this.get('model.width') || '').toUpperCase();
    const widthIsValid = width !== '' && Object.keys(WIDTHS).includes(width);
    return WIDTHS[widthIsValid ? width: 'SMALL'];
  }),

  isDismissible: computed('model.isDismissible', function() {
    return this.model.isDismissible ?? true;
  }),

  /**
   * @param {Boolean}   Set this on model.isShowCancelButton to show or hide the cancel button
   */
  isShowCancelButton: computed('hasCancelButtonText', 'model.isShowCancelButton', function() {
    return this.get('model.isShowCancelButton') || this.get('hasCancelButtonText');
  }),

  /**
   * This is the sanitized body text.  Set this through model.bodyText and we only support the tags
   * in this sanitization method.
   *
   * @type {String}
   */
  bodyTextSanitized: computed('model.bodyText', function() {
    return this.model.bodyText
      ? htmlSafe(this.model.bodyText)
      : null;
  }),

  confirmTask:  task(function *() {
    if(typeof this.get('model.confirmAction') === 'function') {
        // model.confirmAction should return a promise of some kind so that it can run
        // before the modal closes.
        yield this.get('model.confirmAction').bind(this)();
        closeModal(this);
    } else {
      closeModal(this);
    }
  }),
  cancelTask: task(function *() {
    if(typeof this.get('model.cancelAction') === 'function') {
      // model.confirmAction should return a promise of some kind so that it can run
      // before the modal closes.
      yield this.get('model.cancelAction').bind(this)();
      closeModal(this);
    } else {
      closeModal(this);
    }
  }),
  actions: {
    cancelAction() {
      this.get('cancelTask').perform();
    },
    confirmAction() {
      this.get('confirmTask').perform();
    },
  }
});

export default ConfirmationModal;
